import type {
  GatedContentFormData,
  GatedContentStore,
} from '@/schemas/stores/gatedContentStoreSchema';
import { persistentMap } from '@nanostores/persistent';

export const gatedContentStore = persistentMap<GatedContentStore>(
  'gatedContent:',
  {
    formSubmitted: 'false',
    submittedPages: [],
    formSubmissionData: {
      first_name: '',
      last_name: '',
      email: '',
      company: '',
      country: '',
      state: '',
      phone: '',
      Name: '',
      handler_key: 'newsletter-subscribe',
    },
    pdfDownloaded: 'false',
    downloadedPages: {},
  },
  {
    encode: (value: string | GatedContentFormData) => JSON.stringify(value),
    decode: (value: string) => JSON.parse(value),
  },
);
